<template>
  <Modal
    id="credit-card-refund"
    title="Fazer Restituição"
    :active.sync="active"
    @close="close"
  >
    <div>
      <div>
        <span class="font-semibold">Valor da transação: </span>
        <span>{{ paymentValue | currency }}</span>
      </div>
      <div>
        <span class="font-semibold">Valor já restituído: </span>
        <span>{{ refundValue | currency }}</span>
      </div>
      <div>
        <span class="font-semibold">Valor disponível para restituição: </span>
        <span>{{ availableRefund | currency }}</span>
      </div>
    </div>
    <div v-if="allowRefund" class="mt-4">
      <div class="flex flex-col">
        <label for="Valor a restituir" class="vs-select--label"
          >Valor a restituir</label
        >
        <money
          class="w-full vs-inputx vs-input--input normal"
          name="Valor a restituir"
          id="Valor a restituir"
          v-model="newRefundValue"
          v-validate="{
            required: true,
            min_value: 0.01,
            max_value: availableRefund,
          }"
          :state="validateState(veeFields, veeErrors, 'Valor a restituir')"
          :class="validateStateClass(veeFields, veeErrors, 'Valor a restituir')"
          v-bind="money"
          :danger-text="dangerText('Valor a restituir')"
        ></money>
        <span style="color: #eb6364" class="text-xs">{{
          dangerText('Valor a restituir')
        }}</span>
      </div>

      <div class="mt-4 w-full text-right">
        <vs-button
          color="success"
          type="gradient"
          :disabled="isFormInvalid"
          @click="doRefund"
        >
          Confirmar
        </vs-button>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import notify from '../../utils/notify';
import checkoutService from '../../services/checkout';
import { Money } from 'v-money';
import utilsList from '../../utils/list';

export default {
  name: 'modal-credit-card-refund',
  components: {
    Modal,
    Money,
  },
  props: {
    activeProp: {
      type: Boolean,
      default: false,
    },
    purchaseIdProp: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      active: false,
      refunds: [],
      paymentValue: 0,
      refundValue: 0,
      newRefundValue: '',
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      newStatus: '',
    };
  },
  computed: {
    availableRefund() {
      const paymentCents = this.paymentValue * 100;
      const refundCents = this.refundValue * 100;

      const availableCents = paymentCents - refundCents;

      const available = availableCents / 100;
      return available.toFixed(2);
    },
    allowRefund() {
      return this.refundValue < this.paymentValue;
    },
    isFormInvalid() {
      return this.$validator.errors.any();
    },
  },
  watch: {
    activeProp() {
      if (this.activeProp) {
        this.open();
      }
    },
  },
  methods: {
    dangerText(field) {
      const errorMessage = this.veeErrors.items.find(
        (item) => item.field === field,
      );

      return errorMessage ? errorMessage.msg : '';
    },
    async open() {
      try {
        const data = await checkoutService.getCreditCardRefunds(
          this.purchaseIdProp,
        );

        this.refunds = data.refunds || [];
        this.paymentValue = data.paymentValue || 0;
        this.refundValue = data.refundValue || 0;
        this.newStatus = data.status;

        this.active = this.activeProp;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    close() {
      this.newRefundValue = '';
      this.active = false;
      this.$emit('close', {
        purchaseId: this.purchaseIdProp,
        status: this.newStatus,
        refunds: this.refunds,
      });
    },
    async doRefund() {
      const formValid = await this.$validator.validateAll();
      if (!formValid) {
        return;
      }

      const payload = {
        refund_value: this.newRefundValue,
      };
      this.$vs.loading();
      try {
        const data = await checkoutService.createCreditCardRefund(
          this.purchaseIdProp,
          payload,
        );

        this.refunds = data.refunds;
        this.paymentValue = data.paymentValue;
        this.refundValue = data.refundValue;
        this.newStatus = data.status;

        notify.notifySuccess(this.$vs, data.message);
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
        this.close();
      }
    },
  },
};
</script>
<style>
#credit-card-refund.con-vs-popup .vs-popup {
  width: fit-content !important;
  min-width: 25% !important;
}
</style>
